import { useState } from "react";
import LazyLoad from "react-lazyload";
import { Modal } from "react-bootstrap";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const VocationalClubmiddle = () => {
  const homeMenu = [
    { label: "MUN", link: "/Mun" },
    { label: "Glory to the Nation", link: "/GloryOfNation" },
    {
      label: "Spic Macay Cultural and Heritage Club",
      link: "/SpocmacyColtoralHeritage",
    },
    {
      label: "Vocational Education Clubs (Middle Wing) ",
      link: "/vocationalClubmiddle",
    },
    {
      label: "Vocational Education Clubs (Senior Wing)",
      link: "/vocationalClub",
    },
    {
      label: "Vocational Education Clubs (Primary Wing)",
      link: "/VocationalClubPrimary",
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState({ title: "", url: "" });

  const handleOpenModal = (title, url) => {
    setSelected({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const brochures = [
    {
      title: "GRADE VIII_SKILL EDUCATION CURRICULUM",
      url: "https://online.anyflip.com/wglve/nste/mobile/index.html",
    },
    {
      title: "GRADE VII_SKILL EDUCATION CURRICULUM",
      url: "https://online.anyflip.com/wglve/uzfl/mobile/index.html",
    },
    {
      title: "GRADE VI_SKILL EDUCATION CURRICULUM",
      url: "https://online.anyflip.com/wglve/ygme/mobile/index.html",
    },
    {
      title: "GRADE V_SKILL EDUCATION CURRICULUM",
      url: "https://online.anyflip.com/wglve/ecul/mobile/index.html",
    },
    {
      title: "GRADE IV_SKILL EDUCATION CURRICULUM",
      url: "https://online.anyflip.com/wglve/bicl/mobile/index.html",
    },
    {
      title: "LITERARY CIRCLE",
      url: "https://online.anyflip.com/wrkqw/itti/mobile/index.html",
    },
    {
      title: "FITBITS",
      url: "https://online.anyflip.com/wrkqw/xquv/mobile/index.html",
    },
    {
      title: "GLOBAL LEADERS",
      url: "https://online.anyflip.com/wrkqw/buir/mobile/index.html",
    },

    {
      title: "DANCEPIRATION",
      url: "https://online.anyflip.com/wrkqw/xfwx/mobile/index.html",
    },

    {
      title: "ARYABHATA CLUB",
      url: "https://online.anyflip.com/wrkqw/wjbx/mobile/index.html",
    },
    {
      title: "CREATIVE POD",
      url: "https://online.anyflip.com/wrkqw/jnwp/mobile/index.html",
    },
    {
      title: "CODERS CLUB",
      url: "https://online.anyflip.com/wrkqw/shcx/mobile/index.html",
    },

    {
      title: "HOME ECONOMIC CLUB",
      url: "https://online.anyflip.com/wrkqw/yprs/mobile/index.html",
    },
    {
      title: "BANKING AND FINANCE",
      url: "https://online.anyflip.com/wrkqw/hrcv/mobile/index.html",
    },
    {
      title: "DESIGN THINKING AND INNOVATION",
      url: "https://online.anyflip.com/wrkqw/nvkg/mobile/index.html",
    },
    {
      title: "RHYTHM AND FUSION CLUB",
      url: "https://online.anyflip.com/wglve/iegj/mobile/index.html",
    },
    {
      title: "ROBOTRONICS CLUB",
      url: "https://online.anyflip.com/wglve/jvcu/mobile/index.html",
    },
    {
      title: "SCIENCEPORIUM CLUB",
      url: "https://online.anyflip.com/wglve/ripw/mobile/index.html",
    },
    {
      title: "SELF DEFENCE",
      url: "https://online.anyflip.com/wglve/ltyh/mobile/index.html",
    },
    {
      title: "TED TALK",
      url: "https://online.anyflip.com/wglve/ylpy/mobile/index.html",
    },
    {
      title: "MASQUERADE CLUB",
      url: "https://online.anyflip.com/wrkqw/xovv/mobile/index.html",
    },
    {
      title: "MASS MEDIA CLUB",
      url: "https://online.anyflip.com/wrkqw/iojc/mobile/index.html",
    },
    {
      title: "MASTERMIND CLUB ",
      url: "https://online.anyflip.com/wrkqw/muog/mobile/index.html",
    },
    {
      title: "MAVERICK CLUB ",
      url: "https://online.anyflip.com/wrkqw/ilyh/mobile/index.html",
    },
    {
      title: "MICHELANGELO CLUB ",
      url: "https://online.anyflip.com/wrkqw/abyt/mobile/index.html",
    },
    {
      title: "STROKES AND LETTERS CLUB ",
      url: "https://online.anyflip.com/wglve/uvhi/mobile/index.html",
    },

    {
      title: "SWARAAGYA CLUB ",
      url: "https://online.anyflip.com/wglve/fdwu/mobile/index.html",
    },
    {
      title: "TALKING HEADS CLUB ",
      url: "https://online.anyflip.com/wglve/kbhk/mobile/index.html",
    },
    {
      title: "TRAVEL & TOURISM + CULTURE & HERITAGE CLUB ",
      url: "https://online.anyflip.com/wglve/dqod/mobile/index.html",
    },
    {
      title: "WESTERN MELODIES CLUB ",
      url: "https://online.anyflip.com/wrkqw/szap/mobile/index.html",
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/blog-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Vocational Education Clubs (Middle Wing)"
                breadEnd="Vocational Education Clubs"
                breadMid="Vocational Education Clubs (Middle Wing)"
              />
            </div>
          </div>
          <div className="row">
            {brochures.map((item, index) => (
              <div className="col-xl-3 col-md-6 col-sm-12" key={index}>
                <div
                  className="vocationalClub"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenModal(item.title, item.url)}
                >
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vocational-education-clubs.jpg"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </LazyLoad>
                  <p>{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selected.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={selected.url}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title={selected.title}
          ></iframe>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default VocationalClubmiddle;
